export function cleanObject(obj = {}) {
  if (typeof obj !== 'object' || obj === null) {
    throw new Error('Argument must be an object');
  }

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (value === '' || value === null) {
        return [key, undefined];
      }
      return [key, value];
    })
  );
}